import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './FormComponent.css'; // Import custom CSS
import axios from 'axios';

const FormComponent = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNo: '',
    houseNo: '',
    city: '',
    state: '',
    country: '',
    paymentMethod: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    
    axios.post('http://localhost:9000/send', formData)
      .then(res => {
        console.log("Response:", res);
        // Show a success message
        alert("Your payment is successfully done!");
      })
      .catch(err => {
        console.log(err);
      });

    // Reset the form fields after submission
    setFormData({
      name: '',
      phoneNo: '',
      houseNo: '',
      city: '',
      state: '',
      country: '',
      paymentMethod: ''
    });
  };

  return (
    <div className="formimg" style={{width:"100vw" }}>
    <div className="container mt-5 form-container">
      <div className="card-body">
        <h2 className="text-center mb-4 form-title">Payment Form</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name:</label>
            <input
              type="text"
              className="form-control input-field"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Phone No:</label>
            <input
              type="tel"
              className="form-control input-field"
              name="phoneNo"
              value={formData.phoneNo}
              onChange={handleChange}
              placeholder="Enter your phone number"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">House No:</label>
            <input
              type="text"
              className="form-control input-field"
              name="houseNo"
              value={formData.houseNo}
              onChange={handleChange}
              placeholder="House No"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">City:</label>
            <input
              type="text"
              className="form-control input-field"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="City"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">State:</label>
            <input
              type="text"
              className="form-control input-field"
              name="state"
              value={formData.state}
              onChange={handleChange}
              placeholder="State"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Country:</label>
            <input
              type="text"
              className="form-control input-field"
              name="country"
              value={formData.country}
              onChange={handleChange}
              placeholder="Country"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Method:</label>
            <select
              className="form-select input-field"
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleChange}
              required
            >
              <option value="">Select Payment Method</option>
              <option value="Credit Card">Credit Card</option>
              <option value="Debit Card">Debit Card</option>
              <option value="PayPal">PayPal</option>
              <option value="Cash on Delivery">Cash on Delivery</option>
            </select>
          </div>

          <button type="submit" className="btn btn-primary w-100 submit-btn">Submit</button>
        </form>
      </div>
    </div>
    </div>
  );
};

export default FormComponent;
